// Single source of truth for the static Google Reviews.
// To update: edit GOOGLE_REVIEWS below with real reviews copied from Google.
// (Placeholder content until real reviews land.) Add an optional `photo`
// field to a review to show an image at the top of its card.

export const GOOGLE_REVIEW_URL = 'https://g.page/r/CbK8FSvoU3W0EBM/review';

export const GOOGLE_REVIEWS = [
  {
    name: 'Sarah Thompson',
    rating: 5,
    date: '2026-05-18',
    text:
      'AM Facilities did a deep clean of our condo and it has never looked better. Punctual, thorough, and lovely to deal with. Highly recommend!',
  },
  {
    name: 'Michael Chen',
    rating: 5,
    date: '2026-05-02',
    text:
      'We use them for our office every week. Reliable, detail-oriented, and the team is always professional. The booking process was effortless.',
  },
  {
    name: 'Priya Patel',
    rating: 5,
    date: '2026-04-21',
    text:
      'Anna and her team are fantastic. They handled our move-out clean and we got our full deposit back. Spotless work and fair pricing.',
  },
  {
    name: 'David Rodriguez',
    rating: 5,
    date: '2026-04-05',
    text:
      'The home maintenance inspection caught a small leak before it became a costly repair. Genuinely proactive service — exactly what they promise.',
  },
  {
    name: 'Emily Nguyen',
    rating: 5,
    date: '2026-03-12',
    text:
      'Eco-friendly products, friendly staff, and a sparkling house every time. I recommend AM Facilities to everyone in the GTA.',
  },
];

export function clampRating(rating) {
  const n = Math.round(Number(rating));
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(5, n));
}

export function getReviewStats(reviews = GOOGLE_REVIEWS) {
  const valid = (reviews || []).filter((r) => r && Number.isFinite(Number(r.rating)));
  const count = valid.length;
  if (count === 0) return { count: 0, average: 0 };
  const sum = valid.reduce((acc, r) => acc + clampRating(r.rating), 0);
  return { count, average: Math.round((sum / count) * 10) / 10 };
}

export function relativeDate(iso, now = new Date()) {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return String(iso == null ? '' : iso);
  const days = Math.max(0, Math.round((now.getTime() - then.getTime()) / 86400000));
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days} days ago`;
  if (days < 30) {
    const w = Math.round(days / 7);
    return `${w} week${w === 1 ? '' : 's'} ago`;
  }
  if (days < 365) {
    const m = Math.round(days / 30);
    return `${m} month${m === 1 ? '' : 's'} ago`;
  }
  const y = Math.round(days / 365);
  return `${y} year${y === 1 ? '' : 's'} ago`;
}

export function getInitials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return (first + last).toUpperCase();
}
